export interface XY {
  x: number;
  y: number;
}

export interface XYZ extends XY {
  z: number;
}

export interface Dimensions {
  w: number;
  h: number;
}

export interface Bounds {
  width: number;
  height: number;
  x: number;
  y: number;
}
